import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=35671dcd&scoped=true&"
import script from "./HeadInfo.vue?vue&type=script&lang=js&"
export * from "./HeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=35671dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35671dcd",
  null
  
)

export default component.exports